<template>

    <div class="order-index">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Orders</h1>
            </div>

            <div class="flex mb-4 justify-end">
                <router-link :to="{ name: 'place-order' }" class="btn">Place Order</router-link>
            </div>
        </div>

        <OrderIndexFilterBar v-model="indexModel" v-if="indexModel"  @submitFilter="indexModel.load()" @resetFilters="indexModel.resetFilters()"></OrderIndexFilterBar>

        <div class="py-4" v-if="indexModel.isLoaded()">
            <div class="index-table" v-if="indexModel.hasResults()">
                <div>
                    <div>
                        <table>
                            <thead>
                            <tr class="flex">
                                <th scope="col" class="w-2/6 p-3 text-left tracking-wider">
                                    Product
                                </th>
                                <th scope="col" class="w-1/6 p-3 text-center tracking-wider">
                                    Status
                                </th>
                                <th scope="col" class="w-1/6 text-right lg:text-center relative p-3">
                                    Gross / Net
                                </th>
                                <th scope="col" class="w-1/6 hidden lg:table-cell text-center relative p-3">
                                    Discount / Fee
                                </th>
                                <th scope="col" class="w-1/6 hidden lg:table-cell text-right relative p-3">
                                    Created
                                </th>
                            </tr>
                            </thead>
                            <tbody class="flex flex-col justify-between overflow-y-scroll w-full max-h-96 xl:max-h-120">
                                <tr class="flex px-2 colored-row cursor-pointer" v-for="order in indexModel.getData()" @click.prevent="selectOrder(order.reference)">
                                    <td class="w-2/6 ">
                                        <span class="font-medium">{{ order.reference }}</span><br>
                                        <span class="text-xs text-gray-500">
                                            {{ formatDate(order.updated_at) }}
                                        </span>
                                    </td>
                                    <td class="w-1/6 text-center items-center">
                                        <span :class="`status-box ${statusBox(order.status)}`">
                                            {{ convertStatus(order.status) }}
                                        </span>
                                    </td>
                                    <td class="w-1/6 text-right lg:text-center" >
                                        <span class="text-gray-700 font-medium">{{ formatCurrency(order.currency, order.gross_total / 100) }}</span><br>
                                        <span class="text-xs text-gray-500">{{formatCurrency(order.currency, order.net_total / 100) }}</span>
                                    </td>
                                    <td class="w-1/6 hidden lg:table-cell text-center">
                                        <span class="text-gray-700 font-medium">{{ formatCurrency(order.currency, order.discount / 100) }}</span><br>
                                        <span class="text-xs text-gray-500">{{formatCurrency(order.currency, order.transaction_fee / 100) }}</span>
                                    </td>
                                    <td class="w-1/6 hidden lg:table-cell text-right">
                                        <span class="text-xs block" :title="formatDate(order.updated_at)">{{ formatDate(order.updated_at) }}</span>
                                        <span class="text-xs">Created by </span> <span class="text-xs text-gray-500 font-medium">{{ order.account_name }}</span>
                                    </td>
                                </tr>
                                <tr class="py-6 text-xs font-medium">
                                    <infinite-loading @infinite="infiniteHandler">
                                        <div slot="spinner">Loading...</div>
                                        <div slot="no-more">No more Orders</div>
                                    </infinite-loading>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="no-results panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Orders Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any orders, <router-link :to="{ name: 'place-order' }">create an order</router-link>.
                    </p>
                </div>
            </div>
        </div>
        <Loading message="Loading Orders" v-else></Loading>

    </div>

</template>

<script>
import Vue from "vue";
import Loading from "../Support/Loading";
import InfiniteLoading from "vue-infinite-loading";
import OrderIndexFilterBar from "./OrderIndexFilterBar";
import {FormattingMixin, HttpStatusMixin, PermissionMixin} from "../../support/mixins";
import {OrderIndex} from "../../app/Order/OrderIndex";

export default Vue.extend({
    name: "OrderItemIndex",
    mixins: [PermissionMixin, FormattingMixin, HttpStatusMixin],
    components: {
        OrderIndexFilterBar,
        InfiniteLoading,
        Loading
    },
    data() {
        return {
            indexModel: new OrderIndex
        }
    },
    methods: {
        selectOrder(reference) {
            this.$router.push({ name: 'order.show', params: { reference: reference }});
        },
        infiniteHandler($state) {
            this.indexModel.infiniteLoadingHandler($state);
        },
    },
    mounted() {
        this.indexModel.load();
    }
});
</script>
